/**
 * Curated Blueprint category taxonomy.
 *
 * These are the canonical category tags that drive the grouped sections on the
 * Blueprints → Templates tab (see PLAN.md § 2.2 and docs/blueprints/categories.md).
 *
 * Rules:
 *  - `id` must exactly match the tag string carried by a template's `metadata.tags`.
 *  - A template may carry multiple category ids and will appear in every matching section.
 *  - Free-form tags (e.g. `helm`, `nodejs`, `vibe-coding`) are still searchable but do
 *    not create top-level sections; they are NOT listed here.
 *  - To add a new category: add an entry here AND update docs/blueprints/categories.md.
 */
export interface BlueprintCategory {
  /** Literal tag value used in template `metadata.tags`. */
  id: string;
  /** Human-readable display name shown as the section heading. */
  label: string;
  /** One-sentence description shown as the section subtitle. */
  description: string;
}

export const BLUEPRINT_CATEGORIES: BlueprintCategory[] = [
  {
    id: 'onboarding',
    label: 'Onboarding',
    description:
      'Get a new service, repository, or team component up and running in the Make ecosystem.',
  },
  {
    id: 'infra',
    label: 'Infrastructure',
    description:
      'Configure Helm charts, Kubernetes resources, CI/CD pipelines, and other platform primitives.',
  },
  {
    id: 'experimentation',
    label: 'Experimentation',
    description:
      'AI workloads, internal apps, and proof-of-concept projects that live outside the standard delivery track.',
  },
  {
    id: 'backstage',
    label: 'Backstage',
    description:
      'Catalog hygiene and developer standards: registering APIs, components, TechDocs, and Backstage entities.',
  },
];
